<!-- SIDEBAR CONTENT -->
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">

    <div class="p-24">
        <button mat-raised-button
                class="mat-accent add-todo-button w-100-p"
                (click)="newResource()"
                aria-label="New resource"
                *appIsGranted="['Resources', 'CREATE']"
        >
            {{'New'|translate}}
        </button>
    </div>

    <div class="nav material2" *appIsGranted="['Resources', 'READ']">

        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
            <!-- This is the tree node template for leaf nodes -->
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                <li class="mat-tree-node">
                    <!-- use a disabled button to provide padding for tree leaf -->
                    <button mat-icon-button disabled (click)="filterListByCategory(node.id)"></button>
                    <a matTreeNodeToggle class="nav-link" [routerLinkActive]="['active', 'accent']" (click)="filterListByCategory(node.id)">{{node.name}}</a>
                </li>
            </mat-tree-node>
            <!-- This is the tree node template for expandable nodes -->
            <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                <li>
                    <div class="mat-tree-node">
                        <button mat-icon-button matTreeNodeToggle
                                [attr.aria-label]="'toggle ' + node.name"
                                (click)="filterListByCategory(node.id)">
                            <mat-icon class="mat-icon-rtl-mirror">
                                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                            </mat-icon>
                        </button>
                        <a matTreeNodeToggle class="nav-link" [routerLinkActive]="['active', 'accent']" (click)="filterListByCategory(node.id)">{{node.name}}</a>
                    </div>
                    <ul [class.example-tree-invisible]="!treeControl.isExpanded(node)">
                        <ng-container matTreeNodeOutlet></ng-container>
                    </ul>
                </li>
            </mat-nested-tree-node>
        </mat-tree>
        <br/>
        <!--        <a class="nav-link" matRipple (click)="manageCategories()"-->
        <!--           [routerLinkActive]="['active', 'accent']">-->
        <!--            <span>Modify</span>-->
        <!--        </a>-->

    </div>

</div>
<!-- / SIDEBAR CONTENT -->
